import '../helper/jquery-global';
import $ from 'jquery';
import '@fancyapps/fancybox';

export function initFancybox() {
  $.fancybox.defaults.animationEffect = 'zoom';
  $.fancybox.defaults.buttons = [
    'close'
  ];
}
